import { Currency } from '@/core/currency/interfaces';

const JMD: Currency = {
    name: 'Jamaican Dollar',
    demonym: 'Jamaican',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '388',
    symbol: 'J$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'JMD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default JMD;
